export class FitboneConfig {
  public static boxLine_color = 0xFFFF00;
  public static boxLine_gapSize = 1;
  public static boxLine_dashSize = 1;
}
